import { render, staticRenderFns } from "./VetrinaArticolo.vue?vue&type=template&id=53e28a7a&scoped=true"
import script from "./VetrinaArticolo.vue?vue&type=script&lang=js"
export * from "./VetrinaArticolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e28a7a",
  null
  
)

export default component.exports